import { useMutation, useQueryClient } from "@tanstack/react-query"
import { cancelRfqBuyerToAdmin } from "@/lib/api/rfq.api"
import { useAuthStore } from "@/store/auth.store"

export function useCancelRfqBuyerToAdmin() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => cancelRfqBuyerToAdmin(id, accessToken!),
    onSuccess: (_, id) => {
      queryClient.invalidateQueries({ queryKey: ["buyer-rfqs"] })
      queryClient.invalidateQueries({ queryKey: ["buyer-rfq-detail", id] })
      queryClient.invalidateQueries({ queryKey: ["buyer-rfq-status-updates", id] })
    },
  })
}
